import CombineCase from '@/models/CombineCase/CombineCase';

export default class CombineCaseFilter {

	constructor() {
	/*APP_FILTER_DEFINITION*/
		this.id = '';
		this.combineDateFrom = '';
		this.combineDateTo = '';
		this.controlCardId  = '';
		this.controlCardControlCardNumber = '';
		this.partId  = '';
		this.partPartNumber = '';
		this.partNumber4 = '';
		this.partName5 = '';
		this.standarPackagingQty6 = '';
		this.isFromUpload = false;
		this.isSavedToBackend = false;
		this.draftFromUpload = '';
		this.draftMode = '';
	/*END_APP_FILTER_DEFINITION*/
		this.exactType = {
	/*APP_APP_FILTER_CRITERIA*/
			id : '0',
			combineDateFrom : '0',
			combineDateTo : '0',
			controlCardId : '0',
			controlCardControlCardNumber : '0',
			partId : '0',
			partPartNumber : '0',
			partNumber4 : '0',
			partName5 : '0',
			standarPackagingQty6 : '0',
			isFromUpload : '0',
			isSavedToBackend : '0',
	/*END_APP_FILTER_CRITERIA*/
		};
	}

}